import ViewIcon from "assets/icons/workspace/View.svg?react";

import useActiveEditorView from "pages/DevelopWorkspace/contexts/ActiveEditorViewContext/hooks/useActiveEditorView";
import useActiveDocument from "pages/DevelopWorkspace/contexts/DocumentsContext/hooks/useActiveDocument";
import { useDocuments } from "pages/DevelopWorkspace/contexts/DocumentsContext/hooks/useDocuments";

import { useMenu } from "components/ActionMenu/useMenu";
import { RecordLabelWithIcon } from "components/LeftSidebar/RecordLabelWithIcon";
import { Menu } from "components/LeftSidebar/RecordMenu/RecordMenu";
import { TreeNodeType } from "components/Tree/types";
import { highlightText } from "components/helpers";

import styles from "./styles.module.scss";
import { useLeftSidebarContext } from "../../context";

type Props = {
  node: TreeNodeType;
};

export const InformationSchemaTableLabel = (props: Props) => {
  const { node } = props;
  const { label } = node;
  const {
    actions: { createDocument },
  } = useDocuments();

  const activeDocument = useActiveDocument();
  const { insertTextAtCursorPosition } = useActiveEditorView();
  const menu = useMenu();
  const { databaseSearchState } = useLeftSidebarContext();

  const items = [
    [
      {
        key: "insert",
        text: "Insert view name to script",
        shortcut: "Shift + Click",
        action: () => {
          if (activeDocument) {
            insertTextAtCursorPosition(label);
          }
        },
        testId: "insert-view-name-in-editor-item",
      },
      {
        key: "preview",
        text: "Preview data",
        action: () => {
          const value = `select * from information_schema.${node.label} limit 100`;
          if (activeDocument) {
            createDocument(
              {
                title: node.label,
                content: value,
                context: {
                  ...activeDocument.context,
                  database: { name: node.databaseName || "" },
                  settings: {},
                },
              },
              {
                autoRun: true,
              }
            );
          }
        },
        testId: "preview-data-item",
      },
    ],
  ];

  const icon = <ViewIcon />;

  return (
    <>
      <RecordLabelWithIcon
        icon={icon}
        label={
          <span className={styles.tableLabel}>
            {highlightText({
              searchWord: databaseSearchState,
              textToHighlight: label,
            })}
          </span>
        }
        testId={`i-s-label-${label}`}
      />
      <Menu
        testId="i-s-more-icon"
        items={items}
        menu={menu}
      />
    </>
  );
};
